import { QuillDeltaToHtmlConverter, DeltaInsertOp } from "quill-delta-to-html";

import parseRichText from "lib/parseRichText";

const genAudioTag = (customOp: DeltaInsertOp) => {
  const blot = customOp.insert;
  if (blot.type !== "audio") return "";

  return `<audio src="${blot.value}" controls controlsList="nodownload"></audio>`;
};

export const deltaToHtml = (body: any[]) => {
  const converter = new QuillDeltaToHtmlConverter(body);
  converter.renderCustomWith(genAudioTag);
  const articleBody = converter.convert();
  const html = parseRichText(articleBody);

  return html;
};
